<script>
    import { onMount } from 'svelte';
    import { store } from '../../Store.svelte';
    import {
        calculateUsedWeight,
        getLineWeight,
    } from '../../utils/weightUtils';
    import { lineProps } from '../../data/lineProps';
    export let item;
    export let isPrincipal = null;
    const isSky = $store.requestedServices.isSky;

    const handleAddExtRequired = (extRequired) => {
        if (extRequired) {
            extRequired.map((extId) => {
                let additionalItem =
                    $store.requestedServices.product.extrasMap.movil2_0.find(
                        (item) => item.extId == extId
                    );
                if (additionalItem) {
                    let additionalPlan = {
                        imei: '',
                        plan: additionalItem,
                        portability: 'Y',
                        title: additionalItem.extra.title,
                    };
                    $store.requestedServices.izzimovil = [
                        ...$store.requestedServices.izzimovil,
                        additionalPlan,
                        additionalPlan,
                    ];
                }
            });
        }
    };

    const handleDeleteExtRequired = (extRequired) => {
        if (extRequired) {
            extRequired.map((extId) => {
                let plansAfterDelete =
                    $store.requestedServices.izzimovil.filter(
                        (plan) => plan.plan.extId != extId
                    );
                $store.requestedServices.izzimovil = plansAfterDelete;
            });
        }
    };

    onMount(() => {
        if (
            isPrincipal &&
            $store.requestedServices.product.paqId == item.paqId &&
            $store.requestedServices.izzimovil.filter(
                (element) => element.plan.paqId == item.paqId
            ).length < 1
        ) {
            let planSelected = {
                imei: '',
                plan: item,
                portability: 'Y',
                title: title,
            };
            $store.requestedServices.izzimovil = [
                ...$store.requestedServices.izzimovil,
                planSelected,
            ];
            let extRequired = item.extrasMap.movil2_0.filter(
                (item) => item.extra.title == title
            )[0].extra.extRequired;
            handleAddExtRequired(extRequired);
        }
    });

    let maxValue = 5;
    let minValue =
        isPrincipal && $store.requestedServices.product.paqId == item.paqId
            ? 1
            : 0;
    let isVisibleDescription = false;

    $: value = $store.requestedServices.izzimovil.filter(
        (element) => element.plan.extId === item.extId
    ).length;
    $: minusDisabled = value <= minValue ? 'selector--disabled' : '';
    $: plusDisabled =
        usedWeight +
            getLineWeight(isPrincipal ? item.nombreCode : item.extra.extName) >
        maxValue
            ? 'selector--disabled'
            : '';
    $: usedWeight = calculateUsedWeight($store.requestedServices.izzimovil);

    const { extId, paqId } = item;
    const {
        title,
        subtitle,
        cost,
        promoCost,
        description,
        precioSP,
        extRequired,
    } = isPrincipal ? item : item.extra;

    const costValue =
        $store.requestedServices.isSpMovil && precioSP > 0 ? precioSP : cost;

    const updateDisabledStates = () => {
        minusDisabled = value <= minValue ? 'selector--disabled' : '';
        plusDisabled =
            value >= maxValue ||
            $store.requestedServices.izzimovil.length >= maxValue
                ? 'selector--disabled'
                : '';
    };

    const increment = () => {
        if (value < maxValue) {
            value++;
            addPlan();
            updateDisabledStates();
        }
    };
    const decrement = () => {
        if (value > minValue) {
            value--;
            deletePlan();
            updateDisabledStates();
        }
    };
    const addPlan = () => {
        let planSelected = {
            imei: '',
            plan: item,
            portability: 'Y',
            title: title,
        };
        $store.requestedServices.izzimovil = [
            ...$store.requestedServices.izzimovil,
            planSelected,
        ];
        handleAddExtRequired(extRequired);
    };
    const deletePlan = () => {
        let plans = $store.requestedServices.izzimovil;
        let index = isPrincipal
            ? plans.findLastIndex((plan) => plan.plan.paqId == paqId)
            : plans.findLastIndex((plan) => plan.plan.extId == extId);
        plans.splice(index, 1);
        $store.requestedServices.izzimovil = plans;
        handleDeleteExtRequired(extRequired);
    };
</script>

<div class="label__selectable_wrapper label__selectable_wrapper--plans m-b-10">
    <label for="plan_izzimovil_{extId}" class="label__selectable">
        <span class="label__selectable__indicator"
            ><img
                src="/assets/img/icons/check.svg"
                alt=""
                aria-hidden="true"
            /></span
        >
        <div class="label__description">
            <img
                class="sim-icon"
                src="/assets/img/content/izzi-movil-sim.png"
                alt=""
            />
            <div class="h2 text-fs-18 fw-semibold m-b-5">{title}</div>
            {#if !isVisibleDescription}
                <p class="text-fs-13 m-b-0">
                    {#if lineProps.find((line) => line.title == title)?.expandedDescription}
                        <span
                            >{lineProps.find((line) => line.title == title)
                                .expandedDescription}</span
                        >
                    {/if}
                    <a
                        href="#/"
                        on:click|preventDefault={() =>
                            (isVisibleDescription = true)}
                        class={isSky ? 'blue-dark-text' : 'primary-text'}
                        >Conoce más</a
                    >
                </p>
            {:else}
                <p class="text-fs-13 m-b-0">
                    <a
                        href="#/"
                        on:click|preventDefault={() =>
                            (isVisibleDescription = false)}
                        class={isSky ? 'blue-dark-text' : 'primary-text'}
                        >Ocultar</a
                    >
                </p>
                <p>{isPrincipal ? description : subtitle}</p>
            {/if}
        </div>
        <div class="label__pricing">
            <div class="h2 text-fs-20 fw-semibold">
                {#if promoCost > 0}
                    <span class="gray-text line-through"
                        >$<span>{costValue}</span></span
                    >
                    <span class="isSky ? 'blue-dark-text' : 'primary-text'}"
                        >${promoCost}</span
                    >
                {:else}
                    <span class={isSky ? 'blue-dark-text' : 'primary-text'}
                        >${costValue}</span
                    >
                {/if}
                <span class="text-fs-15 fw-regular">al mes</span>
            </div>
        </div>
        <div class="quantity-selectors borderRadius heightAuto">
            <button
                type="button"
                on:click={decrement}
                class="selector selector--minus borderRadiusLeft heightAuto {minusDisabled}"
                ><span>-</span></button
            >
            <span
                class="quantity-num {isSky ? 'blue-dark-text' : 'primary-text'}"
                >{value}</span
            >
            <button
                type="button"
                on:click={increment}
                class="selector selector--plus borderRadiusRight heightAuto {plusDisabled}"
                ><span>+</span></button
            >
        </div>
    </label>
</div>

<style>
    .heightAuto {
        height: auto !important;
    }
    .borderRadiusLeft {
        border-radius: 50px 0 0 50px !important;
    }
    .borderRadiusRight {
        border-radius: 0 50px 50px 0 !important;
    }
    .borderRadius {
        border-radius: 50px 50px 50px 50px !important;
        max-width: 100px !important;
        min-width: 100px !important;
        margin-left: 10px !important;
    }
</style>
